'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2; /* eslint-disable */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRouter = require('react-router');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _recipes = require('redux/modules/recipes');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RecipesLanding = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user };
}, { changeRecipe: _recipes.changeRecipe }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(RecipesLanding, _Component);

  function RecipesLanding() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, RecipesLanding);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RecipesLanding.__proto__ || (0, _getPrototypeOf2.default)(RecipesLanding)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.handleOnClick = function (item, event) {
      _this.props.changeRecipe(item);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /* *************** */
  /* HANDLE ON CLICK */
  /* *************** */

  (0, _createClass3.default)(RecipesLanding, [{
    key: 'render',


    /* END ON CLICK EVENT */

    value: function render() {
      var styles = require('./Recipes.scss');
      var frittataImg = require('./frittatas.png');
      var pizzaImg = require('./pizza.png');
      var skewerImg = require('./skewers.png');
      var smoothieImg = require('./smoothie.png');
      var chickenImg = require('./chicken.png');
      return _react2.default.createElement(
        'div',
        { className: 'container' },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Recipes' }),
        _react2.default.createElement(
          ReactBootstrap.Col,
          { md: 12 },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h1',
              null,
              'Recipes'
            ),
            _react2.default.createElement(
              'h2',
              null,
              'Fruit and vegie-based meals and snacks'
            )
          ),
          _react2.default.createElement('div', { className: styles.spacer20 }),
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/recipe', className: styles.recipeLink, onClick: this.handleOnClick.bind(this, 0) },
            _react2.default.createElement(
              'div',
              { className: styles.card },
              _react2.default.createElement(
                ReactBootstrap.Row,
                null,
                _react2.default.createElement(
                  ReactBootstrap.Col,
                  { sm: 12, md: 3 },
                  _react2.default.createElement(ReactBootstrap.Image, { src: frittataImg, responsive: true })
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.cardContent },
                  _react2.default.createElement(
                    ReactBootstrap.Col,
                    { sm: 12, md: 9, xs: 12 },
                    _react2.default.createElement(
                      'h3',
                      null,
                      'MAGNIFICENT MAKE-AHEAD MINI-FRITTATAS'
                    ),
                    _react2.default.createElement(
                      'h4',
                      null,
                      'Contains: Eggs, dairy, vegetables.'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      'These mini-frittatas make fantastic snacks or can be paired with a source of grains (e.g. wholegrain bread) and vegies (e.g. salad) for a delicious and nutritious meal.'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      'Packed with eggs, dairy, and vegetables, each provides a good source of protein, vitamins and minerals for growing bodies, with about half a serve of vegies in each mini-frittata.'
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement('div', { className: styles.spacer20 }),
          _react2.default.createElement(
            ReactBootstrap.Row,
            null,
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/recipe', className: styles.recipeLink, onClick: this.handleOnClick.bind(this, 1) },
              _react2.default.createElement(
                ReactBootstrap.Col,
                { md: 3, sm: 12, xs: 12 },
                _react2.default.createElement(
                  'div',
                  { className: styles.card },
                  _react2.default.createElement(ReactBootstrap.Image, { src: pizzaImg, responsive: true }),
                  _react2.default.createElement(
                    'div',
                    { className: styles.cardContent },
                    _react2.default.createElement(
                      'h3',
                      null,
                      'PIZZA PEOPLE'
                    ),
                    _react2.default.createElement(
                      'h4',
                      null,
                      'Contains: Tomatoes, cheese, mushrooms.'
                    ),
                    _react2.default.createElement(
                      'h5',
                      null,
                      'Makes 6 small pizzas.'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      'Pizzas are perfect for everyone.'
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 9, sm: 12, xs: 12 },
              _react2.default.createElement(
                'div',
                { className: styles.card },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/recipe', className: styles.recipeLink, onClick: this.handleOnClick.bind(this, 2) },
                  _react2.default.createElement(
                    ReactBootstrap.Row,
                    null,
                    _react2.default.createElement(
                      ReactBootstrap.Col,
                      { sm: 12, md: 3, xs: 12 },
                      _react2.default.createElement(ReactBootstrap.Image, { src: skewerImg, responsive: true })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: styles.cardContent },
                      _react2.default.createElement(
                        ReactBootstrap.Col,
                        { sm: 12, md: 9, xs: 12 },
                        _react2.default.createElement(
                          'h3',
                          null,
                          'FANTASTICALLY FLEXIBLE FRUIT SKEWERS'
                        ),
                        _react2.default.createElement(
                          'h4',
                          null,
                          'Contains: Fruits!'
                        ),
                        _react2.default.createElement(
                          'p',
                          null,
                          'Fruit skewers are a fun way to get kids in the kitchen and enjoy a variety of fruit. Choose fruits that are soft enough to easily thread skewers through, such as strawberries, grapes, rockmelon. Almost anything goes!'
                        )
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement('div', { className: styles.spacer20 }),
              _react2.default.createElement(
                _reactRouter.Link,
                { to: '/recipe', className: styles.recipeLink, onClick: this.handleOnClick.bind(this, 3) },
                _react2.default.createElement(
                  'div',
                  { className: styles.card },
                  _react2.default.createElement(
                    ReactBootstrap.Row,
                    null,
                    _react2.default.createElement(
                      ReactBootstrap.Col,
                      { sm: 12, md: 3, xs: 12 },
                      _react2.default.createElement(ReactBootstrap.Image, { src: smoothieImg, responsive: true })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: styles.cardContent },
                      _react2.default.createElement(
                        ReactBootstrap.Col,
                        { sm: 12, md: 9, xs: 12 },
                        _react2.default.createElement(
                          'h3',
                          null,
                          'BEAUTIFUL BANANA AND BERRY SMOOTHIES'
                        ),
                        _react2.default.createElement(
                          'h4',
                          null,
                          'Contains: Banana, blueberry, raspberry, milk, oats.'
                        ),
                        _react2.default.createElement(
                          'h5',
                          null,
                          'Makes 2'
                        ),
                        _react2.default.createElement(
                          'p',
                          null,
                          'This smoothie provides 1 serve of fruit and 1 serve of dairy in a delicious smoothie. Add a weetbix or 2/3 cup of oats to add a serve of grains - this would make for a good breakfast, especially in Summer.'
                        )
                      )
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement('div', { className: styles.spacer20 }),
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/recipe', className: styles.recipeLink, onClick: this.handleOnClick.bind(this, 4) },
            _react2.default.createElement(
              'div',
              { className: styles.card },
              _react2.default.createElement(
                ReactBootstrap.Row,
                null,
                _react2.default.createElement(
                  ReactBootstrap.Col,
                  { sm: 12, md: 3 },
                  _react2.default.createElement(ReactBootstrap.Image, { src: chickenImg, responsive: true })
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.cardContent },
                  _react2.default.createElement(
                    ReactBootstrap.Col,
                    { sm: 12, md: 9, xs: 12 },
                    _react2.default.createElement(
                      'h3',
                      null,
                      'CHEESY CHICKEN MEATBALLS'
                    ),
                    _react2.default.createElement(
                      'h4',
                      null,
                      'Contains: Vegetables, chicken mince, carrots, eggs.'
                    ),
                    _react2.default.createElement(
                      'h5',
                      null,
                      'Makes 25 balls.'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      'Adding vegetables to mince, such as meatballs, Bolognese sauce, lasagne and burger rissoles to a common way to add in extra vegies without changing the meals kids enjoy very much (and tasting just as good)!'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      'Get kids involved when rolling balls by hand!'
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return RecipesLanding;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  recipe: _propTypes2.default.number,
  changeRecipe: _propTypes2.default.func.isRequired
}, _temp2)) || _class);
/* eslint-enable */

exports.default = RecipesLanding;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/RecipesLanding/RecipesLanding.js
// module id = 1286
// module chunks = 0